import { FieldProps } from "react-final-form";
import { useSlideInContext } from "../SlideInProvider";
import { useMutation } from "@apollo/client";
import { AddCustomFieldMutation, AddCustomFieldMutationVariables, CustomFieldType } from "../../../__generated__/graphql";
import { ADD_CUSTOMFIELD } from "../../../mutations";
import { useParams } from "react-router";
import { GET_LOCATION_CUSTOMFIELDS } from "../../../queries";
import { useManageModal } from "ui";
import { LocationDataType } from "../../../types";
import { NewCustomFieldForm, NewCustomFormSchema } from "../../Forms";

export default function AddCustomField({ location }: { location: LocationDataType }) {
    const { id } = useParams()
    const { openModal } = useManageModal()
    const { toggleDrawer } = useSlideInContext()
    const [addCustomField, { error }] = useMutation<AddCustomFieldMutation, AddCustomFieldMutationVariables>(ADD_CUSTOMFIELD, {
        refetchQueries: [GET_LOCATION_CUSTOMFIELDS]
    })
    const handleAddCustomFieldSubmission = async (values: NewCustomFormSchema) => {
        const _position = (location?.customFields?.length ?? 0) > 0 ? 1 : 0
        const input = {
            locationId: location?.id ?? id,
            type: values.type as CustomFieldType,
            name: values.name,
            description: values.description,
            placeholder: values.name,
            required: values.required ?? false,
            position: _position
        }
        try {
            const response = await addCustomField({
                variables: { input },
                onError(error, clientOptions) {
                    console.log("query Error: ", error, clientOptions)
                    openModal({ type: "DUPLICATE_FIELD", cancelButtonLabel: "Close" })
                }
            })

            if (response.data) {
                toggleDrawer()
            }
        } catch (err) {
            openModal({ type: "DUPLICATE_FIELD", cancelButtonLabel: "Close" })
        }
    }
    const handleCancel = () => {
        toggleDrawer()
    }
    return (
        <NewCustomFieldForm
            onSubmit={handleAddCustomFieldSubmission}
            onCancel={handleCancel}
        />
    )
}

